import { render } from "./index.vue?vue&type=template&id=2f55a8c8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2f55a8c8&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/ringg_deliveryhub-app_production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__